export default "__VITE_ASSET__4bd35d35__"